export default __webpack_public_path__ + "static/icon-35d442a4c10969d41d240428e908ce8b.webp";